<template>
  <b-modal
    :id="id"
    size="lg"
    body-class="bg-white"
    :title="title"
    cancel-variant="default"
    @show="initModal"
    @hidden="resetModal"
    @ok="handleClick"
  >
    <b-form-group
      v-for="form in fields"
      :key="form.label"
      :id="form.id"
      :label="form.label"
      :label-for="`${form.label}-${form.id}`"
    >
      <b-form-textarea
        v-if="
          form.label !== 'image' &&
          form.label !== 'event_start_at' &&
          form.label !== 'event_end_at' &&
          form.label !== 'icon'
        "
        :id="`${form.label}-${form.id}`"
        v-model="form.value"
        required
      ></b-form-textarea>

      <b-form-datepicker
        v-else-if="
          form.label == 'event_start_at' || form.label == 'event_end_at'
        "
        :min="new Date()"
        :id="`${form.label}-${form.id}`"
        v-model="form.value"
      ></b-form-datepicker>

      <div v-else-if="form.label == 'image' || form.label == 'icon'">
        <div class="">
          <img
            class="img-fluid"
            :src="typeof form.value == 'object' ? imagePath : form.value"
            :alt="typeof form.value == 'object' ? form.value.name : form.value"
          />
        </div>
        <b-form-file
          v-model="form.value"
          class="mt-3"
          @change="handleChangeFile"
        ></b-form-file>
      </div>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: "DataModal",
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "Modal",
    },
    forms: {
      type: Array,
      default: () => [],
    },
    formsData: {
      type: Object,
      required: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: null,
      imagePath: null,
    };
  },
  methods: {
    initModal() {
      this.fields = this.forms.reduce((acc, f, idx) => {
        if (f == "no" || f == "aksi" || f == "created_at" || f == "updated_at")
          return [...acc];

        if (f == "image")
          return [
            ...acc,
            {
              id: `${f}-${idx}`,
              label: f,
              value: this.isEdit ? this.formsData[f] : [],
            },
          ];

        return [
          ...acc,
          {
            id: `${f}-${idx}`,
            label: f,
            value: this.isEdit ? this.formsData[f] : "",
          },
        ];
      }, []);
    },
    resetModal() {
      this.fields = null;
      this.imagePath = null;
    },
    handleClick() {
      this.$emit("click-ok", this.fields);
    },
    handleChangeFile(e) {
      const url = URL.createObjectURL(e.target.files[0]);

      this.imagePath = url;
    },
  },
};
</script>
